<template>
  <div class="flex">
    <NInput
      leading="i-lucide-circle-dollar-sign"
      placeholder="Search"
      class="pr-12"
    >
      <template #trailing>
        <span class="text-sm">
          USD
        </span>
      </template>
    </NInput>
  </div>
</template>
